
import { defineComponent, PropType, reactive } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'

// types
import { FullOrderReceiverT } from '@/core/types/orders.types'

export default defineComponent({
    components: {
        'the-button': TheButton,
    },
    props: {
        receiver: {
            type: Object as PropType<FullOrderReceiverT>,
            required: true,
        },
        index: {
            type: Number,
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        withoutUpdate: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['update'],
    setup(props, { emit }) {
        const state = reactive({
            is_opened: false,
        })

        const open = () => {
            state.is_opened = true
        }

        const close = () => {
            state.is_opened = false
        }

        const emitUpdate = () => {
            emit('update', props.index)
        }

        return { state, open, close, emitUpdate }
    },
})
